import moment from 'moment'
import { defaultFormState, executeTypeOptions, schedulerTypeOptions } from '../consts'

// 处理执行类型变化
export const handleExecuteTypeChange = (
  value: number,
  setFormState: (fn: (prev: any) => any) => void,
  createForm: any,
) => {
  setFormState(prev => ({
    ...prev,
    executeType: value,
  }))

  if (value === 3) {
    createForm.setFieldValue('schedulerType', 'scheduler_type_daily')
    setFormState(prev => ({ ...prev, schedulerType: 'scheduler_type_daily' }))
  } else if (value === 2) {
    createForm.setFieldValue('schedulerType', 'scheduler_type_reserve')
    setFormState(prev => ({ ...prev, schedulerType: 'scheduler_type_reserve' }))
  } else {
    createForm.setFieldValue('schedulerType', 'scheduler_type_immediate')
    setFormState(prev => ({ ...prev, schedulerType: 'scheduler_type_immediate' }))
  }
}

// 处理执行模板最新用例变化
export const handleExecuteTemplateLatestCaseChange = (
  checked: boolean,
  setFormState: (fn: (prev: any) => any) => void,
  createForm: any,
  setTemplateData: (fn: (prev: any) => any) => void,
  setSelectedTemplateData: (fn: (prev: any) => any) => void,
) => {
  setFormState(prev => ({ ...prev, executeTemplateLatestCase: checked }))
  createForm.setFieldsValue({ executeTemplateLatestCase: checked })

  // 当模板增量更新关闭时，将所有模板的executeUpdate状态重置为false
  if (!checked) {
    setTemplateData(prev => ({
      ...prev,
      list: prev.list.map(item => ({ ...item, executeUpdate: false })),
    }))
    setSelectedTemplateData(prev => prev.map(item => ({ ...item, executeUpdate: false })))
  }
}

// 处理单个模板的开关状态变化
export const handleTemplateSwitchChange = (
  templateId: string,
  checked: boolean,
  formState: any,
  selectedCaseIds: string[],
  setTemplateData: (fn: (prev: any) => any) => void,
  setSelectedTemplateData: (fn: (prev: any) => any) => void,
  templateSelectedCountMap: Record<string, number>,
  templateData: any,
) => {
  // 只有当第一步的模板增量更新开关打开，且是周期任务时，才能操作
  if (formState.executeType !== 3 || !formState.executeTemplateLatestCase) return

  // 检查该模板下的全部用例和已选用例数是否相等
  const selectedCount = templateSelectedCountMap[templateId] || 0
  const template = templateData.list.find((item: any) => item.templateId === templateId)
  const isAllCasesSelected = selectedCount === template?.resourceAmount && template?.resourceAmount > 0
  if (!isAllCasesSelected) return

  setTemplateData(prev => ({
    ...prev,
    list: prev.list.map(item =>
      item.templateId === templateId ? { ...item, executeUpdate: checked } : item,
    ),
  }))
  // 更新 selectedTemplateData 中的 executeUpdate 值
  setSelectedTemplateData(prev =>
    prev.map(item => (item.templateId === templateId ? { ...item, executeUpdate: checked } : item)),
  )
}

// 处理表单值变化
export const handleFormValueChange = (
  _: any,
  allValues: any,
  setFormState: (fn: (prev: any) => any) => void,
) => {
  setFormState(prev => ({ ...prev, ...allValues }))
}

// 构建任务创建参数
export const buildCreateTaskParams = (
  formState: any,
  selectedCaseIds: string[],
  selectedTemplateData: any[],
  templateData: any,
  selectedTemplateIds: string[],
  emailList: any[],
  userId: string,
) => {
  let templateList = selectedTemplateData.map(item => ({
    id: item.templateId,
    useLatestResource: item.executeUpdate,
  }))

  if (templateList.length === 0 && selectedTemplateIds.length > 0) {
    templateList = templateData.list
      .filter(t => selectedTemplateIds.includes(t.templateId))
      .map(t => ({ id: t.templateId, useLatestResource: t.executeUpdate }))
  }

  let schedulerType = ''
  const cronSchedule = {
    dayOfWeek: undefined as number[] | undefined,
    dayOfMonth: undefined as number[] | undefined,
    timeOfDay: '',
    intervalOfHour: undefined,
    intervalOfMinute: undefined,
  }

  if (formState.executeType === 1) {
    schedulerType = 'scheduler_type_immediate'
  }
  if (formState.executeType === 2) {
    schedulerType = 'scheduler_type_reserve'
    cronSchedule.timeOfDay = moment(formState?.taskTime).format('YYYY-MM-DD HH:mm:ss')
  }

  if (formState.schedulerType === 'scheduler_type_monthly') {
    schedulerType = 'scheduler_type_monthly'
    cronSchedule.dayOfMonth = formState.dayOfMonth
    cronSchedule.timeOfDay = formState?.taskTime
      ? moment(formState?.taskTime).format('HH:mm:ss')
      : ''
  }

  if (formState.schedulerType === 'scheduler_type_weekly') {
    schedulerType = 'scheduler_type_weekly'
    cronSchedule.dayOfWeek = formState.dayOfWeek
    cronSchedule.timeOfDay = formState?.taskTime
      ? moment(formState?.taskTime).format('HH:mm:ss')
      : ''
  }

  if (formState.schedulerType === 'scheduler_type_daily') {
    schedulerType = 'scheduler_type_daily'
    cronSchedule.timeOfDay = formState?.taskTime
      ? moment(formState?.taskTime).format('HH:mm:ss')
      : ''
  }

  let deviceIds: string[] = []
  let chainId = '0'
  if (formState.deviceIds.length > 0) {
    chainId = formState.deviceIds[0][0]
    if (chainId === '0') {
      deviceIds.push(formState.deviceIds[0][2])
    } else {
      deviceIds = formState.deviceIds.map(item => item[2])
    }
  }

  return {
    name: formState.name,
    schedulerType: schedulerType,
    userId,
    executionTimes: formState.executionTimes ?? 0,
    groupId: formState.groupId,
    priority: formState.priority,
    deviceId: formState.deviceIds.length > 0 ? formState.deviceIds[1] : '0',
    cronSchedule: cronSchedule,
    resourceIds: selectedCaseIds,
    templateList: templateList,
    agentToTi: {
      agentId: formState.agentId ? formState.agentId[1] : '',
      dnsSinkhole: formState.dnsSinkhole,
    },
    reportConfig: {
      emailList:
        formState?.emailList?.length > 0
          ? emailList
              .filter(item => formState.emailList.includes(item.id))
              .map(item => ({
                id: item.id,
                name: item.name,
                email: item.email,
              }))
          : [],
      condition: formState.condition,
      send: formState.send || false,
      filter: formState.filter || false,
    },
    proxy: {
      address: formState.proxy ? `${formState.protocol}://${formState.proxy}` : '',
      enableAuth: formState.enableAuth,
      account: formState.account,
      password: formState.password,
    },
    speed: formState.speed,
    timeout: formState.timeout,
  }
}

// 处理全选所有模板
export const handleSelectAll = async (
  checked: boolean,
  getTemplateList: any,
  searchTemplateParams: any,
  templateValue: any,
  formState: any,
  executeTemplateLatestCase: boolean,
  setSelectedTemplateIds: (ids: string[]) => void,
  setSelectedTemplateData: (data: any[]) => void,
  setSelectedCaseIds: (ids: string[]) => void,
) => {
  if (checked) {
    try {
      // 获取所有模板数据
      const response = await getTemplateList({
        ...searchTemplateParams,
        page: 1,
        pageSize: 9999, // 使用足够大的数，确保能拉全所有数据
        filterParams: {
          name: String(templateValue.value || ''),
          verificationModeIds: [6], // 验证模式
          sceneIds: [2], // 场景 5 流量安全 // 2 威胁情报
          ...searchTemplateParams.filterParams,
        },
      })

      const allTemplates = response.data.list.map(item => ({
        ...item,
        key: item.templateId,
        executeUpdate: formState.executeType === 3 && executeTemplateLatestCase ? true : false,
      }))

      const allIds = allTemplates.map(item => item.templateId)

      setSelectedTemplateIds(allIds)
      setSelectedTemplateData(allTemplates)
    } catch (error) {
      console.error('Failed to get all templates:', error)
    }
  } else {
    setSelectedTemplateIds([])
    setSelectedTemplateData([])
    // 当取消模板全选时，同时清空用例列表的选中状态
    setSelectedCaseIds([])
  }
}

// 处理用例全选所有
export const handleCaseSelectAll = async (
  checked: boolean,
  selectedCaseIds: string[],
  caseIds: string[],
  setSelectedCaseIds: (ids: string[]) => void,
  getCaseList: any,
  searchCaseParams: any,
  selectedTemplateIds: string[],
  caseData: any,
  setTemplateSelectedCountMap: (map: Record<string, number>) => void,
  executeType: number,
) => {
  if (checked) {
    // 如果是高频任务且当前选中的用例数加上要新增的用例数超过10个，则不允许全选
    if (executeType === 4 && selectedCaseIds.length + (caseIds?.length || 0) > 10) {
      return
    }
    const newSelectedCaseIds = [...new Set([...selectedCaseIds, ...(caseIds || [])])]
    setSelectedCaseIds(newSelectedCaseIds)

    // 获取所有用例的完整数据来计算每个模板的已选用例数
    if (caseIds.length > 0) {
      try {
        const params = { ...searchCaseParams }
        delete params.page
        delete params.pageSize
        const res = await getCaseList({
          ...params,
          queryType: 'query_bind',
          templateId: selectedTemplateIds,
          filterParams: {
            verificationModeId: [6],
            sceneId: [2],
            ...params.filterParams,
          },
          page: 1,
          pageSize: caseData.total > 0 ? caseData.total : 1000, // 获取所有用例
        })

        const allCases: any[] = res?.data?.list || []
        const selectedIdSet = new Set(newSelectedCaseIds)
        const aggregatedSelection = new Map<string, number>()

        // 遍历所有用例，统计每个模板的已选用例数
        allCases.forEach(item => {
          if (!selectedIdSet.has(item.resourceId.toString())) return
          item.templateIds?.forEach((templateId: string) => {
            if (!templateId) return
            const current = aggregatedSelection.get(templateId) || 0
            aggregatedSelection.set(templateId, current + 1)
          })
        })

        // 更新模板已选用例数映射
        const updatedMap: Record<string, number> = {}
        aggregatedSelection.forEach((count, templateId) => {
          updatedMap[templateId] = count
        })
        setTemplateSelectedCountMap(updatedMap)
      } catch (error) {
        console.error('Failed to sync template selection when selecting all use cases:', error)
      }
    }
  } else {
    setSelectedCaseIds([])
    setTemplateSelectedCountMap({})
  }
}

// 保存模板提交
export const saveTemplateSubmit = (
  values: any,
  selectedCaseIds: string[],
  saveCaseToTemplate: any,
  setSaveTemplateModal: (visible: boolean) => void,
) => {
  saveCaseToTemplate({
    name: values.name,
    resourceIds: selectedCaseIds,
    verificationModeIds: [6],
    sceneIds: [2], // 场景 5 流量安全 // 2 威胁情报
  })
    .then(() => {
      setSaveTemplateModal(false)
    })
    .catch(_ => {})
}
